export default {
    system: {
        settings: "设置",
        cancel: "取消",
        confirm: "确认",
        delete: "删除",
        deleteConfirm: "您确定要删除吗？",
        reset: "重置",
        success: "操作成功",
        close: "关闭",
    },
    save: "保存",
    update: "更新",
    search: "搜索",
    reset: "重置",
    delete: "删除",
    delete_success: "删除成功",
    delete_failed: "删除失败",
    created_at: "创建时间",
    actions: "操作",
};
